import { render, staticRenderFns } from "./TourDetailViewHeader.vue?vue&type=template&id=3c3ba20c"
import script from "./TourDetailViewHeader.js?vue&type=script&lang=js&external"
export * from "./TourDetailViewHeader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports